import React, { useState, Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Row, Col } from 'react-flexbox-grid'

import ItemDetails from '../fragments/ItemDetails'
import { availability_intervals } from '../../../tableColumns'
import { DataTable } from 'components/DataTable/'
import { ContentBlock } from 'components/ContentBlock'
import { Form, Text, Number as NumberInput, Checkbox, Select } from 'components/forms'
import { useMutation } from 'components/graphql'
import { updateProductProperties } from '../../../gql/mutation'
import getProduct from '../../../gql/query/getProduct'
import Divider from 'components/Divider'
import updateProperties from '../../../fragments/mutateProductProperties'
import { loadAppConstants } from 'gql/query'

const Orders = ({ data, formData = {}, mutations: { updateItem }, expandedId, blockId }) => {
	const [selectedItem, setSelectedItem] = useState(null)
	const [t, i18n] = useTranslation()
	const [mutate] = useMutation(updateProductProperties)

	const handleChangeDetails = vals => {
		updateItem({ intervals: vals }, { refetchQueries: [{ query: getProduct, variables: { id: data.id } }] })
		if(!vals.id || vals.id === -1) {
			hideDetails()
		} else {
			setSelectedItem(vals)
		}
	}

	const hideDetails = () => setSelectedItem(null)

	const filteredIntervals = Array.isArray(data.intervals) ? data.intervals.filter(({ type }) => type === 1) : []
	const { properties = {} } = data
	const isBlockExpanded = expandedId === blockId
	return(
		<Fragment>
			<ContentBlock blockId={blockId} label={t('product_section.strings.orders')}>
				<Form initialValues={formData} onSubmit={updateItem} smartSubmit>
					<Row>
						<Col xs>
							<Text field='nameInOrder' label={t('product_section.fields.optional_order_designation')} />
							<Select
								label={t('product_section.fields.inventory_unit')}
								field='inventoryUnit'
								remoteOptions={{
									query: loadAppConstants,
									variables: { type: 52, language: i18n.language }
								}}
							/>
						</Col>
						<Col xs>
							<Col type='row'>
								<Select
									label={t('product_section.fields.order_unit')}
									field='orderUnit'
									options={[{ value: 0.5, label: '0.5' }, { value: 1, label: '1' }]}
									inline
									shrink />
								<NumberInput
									label={t('product_section.fields.piece_per_unit')}
									field='numberPerUnit'
									precision={2}
									withControls={false}
									inline
									shrink />
							</Col>
							<Col type='row'>
								<NumberInput
									label={t('product_section.fields.min_order_unit')}
									field='minOrder'
									precision={2}
									withControls={false}
									inline
									shrink />
								<Text
									value={properties.MDEBatchSize || ''}
									label={t('product_section.fields.lot_size_mde')}
									onChange={e => updateProperties({ productId: data.id, MDEBatchSize: e.target.value }, mutate)}
									noForm
									inline
									shrink />
							</Col>
						</Col>
						<Col xs>
							<Divider height={25}/>
							<Checkbox field='isInventory' label={t('product_section.fields.inventory')} />
							<Checkbox field='isForTasting' label={t('product_section.fields.tasteable')} />
							<Checkbox field='canCopy' label={t('product_section.fields.can_copy')} />
							<Checkbox
								noForm
								checked={properties.RetoureMehrereTage}
								onChange={e => updateProperties({ productId: data.id, RetoureMehrereTage: e.target.checked }, mutate)}
								label={t('product_section.fields.returns_several_days')} />
						</Col>
					</Row>
				</Form>
			</ContentBlock>
			{isBlockExpanded &&
				<ContentBlock related alwaysExpanded style={{ ...!selectedItem && { flexBasis: '100%' } }}>
					<DataTable
						data={filteredIntervals}
						columns={availability_intervals(t)}
						withSearch
						selectRow
						sortable={false}
						onRowClick={(state, { original }) => setSelectedItem(original)}
						mutateRow={{
							onRowMutate: id => {
								hideDetails()
								handleChangeDetails({ id })
							}
						}}
						onAddRecord={() => setSelectedItem({})}
						label={t('product_section.strings.sales_availability')}
					/>
				</ContentBlock>
			}
			<ItemDetails
				key={selectedItem ? selectedItem.id : -1}
				data={selectedItem}
				onDataChange={handleChangeDetails}
				isParentExpanded={isBlockExpanded}
				itemType={1} />
		</Fragment>
	)
}

export default Orders

